module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAAAmElEQVR4AWO4ryZzHoj/DzDuZwAzBh7vhzuEgf4AZLfDEHIIQqEAAcMMgFiBgBoFkDpyHAISL4ArIuyj93jUCIDkoeoMyHFIA1TuPh5LApASnADO0ECocSDHIQIgiwgFO1SNARFpIWAIJ1YEGHXIqEMGXV0zWukNa4eMOmTUIaMOGa1r9g8APo/skPeDoK5ZD+sOOAwwVgAAkv/XnBc8y2IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/door-pocket-icon.png
// module id = 472
// module chunks = 0